(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fangster-home-banner"] && !Shopify.designMode) return;
  try {
    
  class FangsterHomeCarousel extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.slides = Array.from(this.querySelectorAll('[data-fg-home-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-fg-home-dot]'));
      this.previousButton = this.querySelector('[data-fg-home-previous]');
      this.nextButton = this.querySelector('[data-fg-home-next]');
      this.pauseButton = this.querySelector('[data-fg-home-pause]');
      this.pauseIcon = this.querySelector('[data-fg-home-pause-icon]');
      this.pauseIconPause = this.querySelector('[data-fg-home-icon-pause]');
      this.pauseIconPlay = this.querySelector('[data-fg-home-icon-play]');
      this.status = this.querySelector('[data-fg-home-status]');
      this.controls = this.querySelector('.fg-home-carousel__controls');
      this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.autoplayEnabled = this.dataset.autoplay === 'true';
      this.interval = Number(this.dataset.interval) || 7000;
      this.manualPaused = false;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (!this.autoplayEnabled && this.pauseButton) this.pauseButton.hidden = true;

      this.previousButton?.addEventListener('click', () => this.move(this.currentIndex - 1, true));
      this.nextButton?.addEventListener('click', () => this.move(this.currentIndex + 1, true));
      this.pauseButton?.addEventListener('click', () => this.togglePause());
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.move(Number(dot.dataset.fgHomeDot), true));
      });

      this.controls?.addEventListener('mouseenter', () => this.stop());
      this.controls?.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', (event) => {
        if (event.target.matches?.(':focus-visible')) this.stop();
      });
      this.addEventListener('focusout', () => {
        window.setTimeout(() => this.start(), 0);
      });
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
      document.addEventListener('shopify:block:select', this.handleBlockSelect);
      this.reducedMotion.addEventListener?.('change', this.handleMotionChange);

      this.update(false);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      this.reducedMotion?.removeEventListener?.('change', this.handleMotionChange);
    }

    handleVisibilityChange = () => {
      if (document.hidden) {
        this.stop();
      } else {
        this.start();
      }
    };

    handleMotionChange = () => {
      this.stop();
      this.start();
    };

    handleBlockSelect = (event) => {
      const selectedIndex = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail?.blockId);
      if (selectedIndex < 0) return;
      this.manualPaused = true;
      this.updatePauseButton();
      this.move(selectedIndex, false);
    };

    move(index, announce) {
      if (this.slides.length < 2) return;
      this.currentIndex = (index + this.slides.length) % this.slides.length;
      this.update(announce);
      this.stop();
      this.start();
    }

    update(announce) {
      this.slides.forEach((slide, index) => {
        const active = index === this.currentIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
          if (active) {
            element.removeAttribute('tabindex');
          } else {
            element.setAttribute('tabindex', '-1');
          }
        });
      });

      this.dots.forEach((dot, index) => {
        const active = index === this.currentIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });

      if (announce && this.status) {
        this.status.textContent = this.dataset.slideLabel
          .replace('__CURRENT__', String(this.currentIndex + 1))
          .replace('__TOTAL__', String(this.slides.length));
      }
    }

    start() {
      if (
        !this.autoplayEnabled ||
        this.manualPaused ||
        this.slides.length < 2 ||
        this.reducedMotion.matches ||
        document.hidden ||
        this.controls?.matches(':hover') ||
        this.querySelector(':focus-visible')
      ) return;
      this.stop();
      this.timer = window.setInterval(() => this.move(this.currentIndex + 1, false), this.interval);
    }

    stop() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }

    togglePause() {
      this.manualPaused = !this.manualPaused;
      this.updatePauseButton();
      if (this.manualPaused) {
        this.stop();
      } else {
        this.start();
      }
    }

    updatePauseButton() {
      if (!this.pauseButton) return;
      const label = this.manualPaused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel;
      this.pauseButton.setAttribute('aria-label', label);
      this.pauseButton.setAttribute('aria-pressed', this.manualPaused ? 'true' : 'false');
      if (this.pauseIconPause) this.pauseIconPause.hidden = this.manualPaused;
      if (this.pauseIconPlay) this.pauseIconPlay.hidden = !this.manualPaused;
    }
  }

  if (!customElements.get('fangster-home-carousel')) {
    customElements.define('fangster-home-carousel', FangsterHomeCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
